var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.389 4.11066H21.6411L20.3974 0.771265C20.2537 0.386749 19.8947 0.132812 19.4945 0.132812H9.50556C9.10506 0.132812 8.74641 0.386749 8.60299 0.771265L7.35859 4.11066H1.61109C0.722736 4.11066 0 4.85417 0 5.76806V22.3423C0 23.2563 0.722736 23.9998 1.61109 23.9998H27.3889C28.2773 23.9998 29 23.2563 29 22.3424V5.76806C29.0001 4.85417 28.2773 4.11066 27.389 4.11066ZM27.0667 22.0109H1.93332V6.09955H8.02333C8.42384 6.09955 8.78249 5.84562 8.9259 5.4611L10.1704 2.12171H18.8301L20.0742 5.4611C20.2176 5.84562 20.5766 6.09955 20.9768 6.09955H27.0668V22.0109H27.0667Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 6.26367C10.751 6.26367 7.70117 9.40151 7.70117 13.258C7.70117 17.1149 10.751 20.2527 14.5001 20.2527C18.2492 20.2527 21.299 17.1149 21.299 13.258C21.299 9.40122 18.2491 6.26367 14.5001 6.26367ZM14.5001 18.2637C11.8173 18.2637 9.63455 16.0186 9.63455 13.2583C9.63455 10.4981 11.8173 8.25292 14.5001 8.25292C17.1829 8.25292 19.3657 10.4984 19.3657 13.2583C19.3657 16.0183 17.1829 18.2637 14.5001 18.2637Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.fa9ec59d738b185675158c0c5d83e0a9.svg";
export { ForwardRef as ReactComponent };